




















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CampaignDto from '@/models/Campaigns/CampaignDto';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import UpdateCampaignGeneralDetailsRequest from '@/models/Campaigns/UpdateCampaignGeneralDetailsRequest';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import ActivityCategoryDto from '@/models/Activities/ActivityCategoryDto';
import ajax from '@/lib/ajax';
import { AppModule } from '@/store/modules/app';

@Component({
    name: 'CampaignGeneralDetailsEdit'
})
export default class CampaignGeneralDetailsEdit extends GiganautVueDialog {

  entity: CampaignDto = new CampaignDto();
  desks: DeskDto[] = [];
  activityCategories: ActivityCategoryDto[] = [];

  get activeCategories() {
    return this.activityCategories.filter(c => c.isActive);
  }

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(CampaignDetailsModule.currentCampaign));
      if (this.entity.branch !== null) {
        this.desks = this.entity.branch.desks;
      }
      if (AgencySettingsModule.agencyUsers) {
        AgencySettingsModule.getAgencyUsers();
      }
      if (AgencySettingsModule.branches) {
        await AgencySettingsModule.getBranches();
      }
      await this.loadActivityCategories();
      //Need to copy the default branch from the branch list if there is one
      //so that the desks are populated correctly 
      if (this.entity.branch) {
        this.entity.branch = this.branches.find((findBranch: BranchDto) => findBranch.id === this.entity.branch.id);
      } 
    }
  }

  @Watch('entity.branch') 
  async onBranchChanged(newVal: BranchDto, oldVal: BranchDto){
    if (newVal) {
      this.desks = newVal.desks;
    } else {
      this.entity.deskId = null;
      this.entity.desk = null;
      this.desks = [];
    }
  }

  get campaign() {
    return CampaignDetailsModule.currentCampaign;
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get agencyUsers() {
    return AgencySettingsModule.agencyUsers;
  }

  get loading() {
    return CampaignDetailsModule.loadingDialog;
  }

  async loadActivityCategories() {
    try {
      const response = await ajax.get('/api/v1/agency/activity-categories');
      this.activityCategories = response.data || [];
    } catch (error) {
      AppModule.handleApiError(error);
      this.activityCategories = [];
    }
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    
    const request = new UpdateCampaignGeneralDetailsRequest()
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    request.ownerId = this.entity.owner.id;
    request.categoryId = this.entity.category ? this.entity.category.id : '';
    if (this.entity.branch) {
      request.branchId = this.entity.branch.id;
    } else {
      request.branchId = null;
    }
    if (this.entity.desk) {
      request.deskId = this.entity.desk.id;
    } else {
      request.deskId = null;
    }
    
    await CampaignDetailsModule.editCampaignGeneralDetails(request)
    this.dialog = false;
  }
}
